import { createNamespacedHelpers } from 'vuex';
import EmailAdapter from 'Core/logged/EmailAdapter.js';
import Feature from 'Services/Feature';
import { getEmailSettings } from 'api/emailEngine/emailEngineService';
import { getMandateTemplate, getSystemEmailTemplate } from 'api/emailEngine/emailEngineService';

const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    data() {
        return {
            account: {},
            signature: '',
            automaticallyAttachDocument: true,
        };
    },
    computed: {
        emailProviderRoute() {
            let route = `/rest/email/sending?linkedtype=${this.linkedtype}&linkedid=${this.linkedid}`;
            if (this.relatedData && Object.keys(this.relatedData).length > 0) {
                route += `&context=${this.context}&relatedtype=${this.relatedData.type}&relatedid=${this.relatedData.id}`;
            }
            return route;
        },
        isSetup() {
            return this.account.isSetup === 'Y';
        },
    },
    methods: {
        async getSettings() {
            await getEmailSettings()
                .then((response) => {
                    this.account = this.getAccountData(response.data.connection);
                    this.automaticallyAttachDocument = response.data.automatically_attach_document;
                    if (response.data.signature && response.data.signature.computed) {
                        this.signature = `<p></p><p>${response.data.signature.computed}</p>`;
                    }
                })
                .catch((error) => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: error,
                    });
                });
        },
        getAccountData(connection) {
            const account = {};
            if (connection === null) {
                account.isSetup = 'N';
                return account;
            }
            account.isSetup = 'Y';
            return account;
        },
        ...popupPanelMapActions(['open']),
        async checkEmailProvider(params = {}, prefill = {}, email = '') {
            await this.getSettings();
            if (this.isSetup) {
                if (this.relatedData && Object.keys(this.relatedData).length > 0) {
                    params.relatedtype = this.relatedData.type;
                    params.relatedid = this.relatedData.id;
                    params.context = this.context;
                }

                if (this.context) {
                    params.context = this.context;
                }

                if (params.template?.type) {
                    if (Feature.isEnabled('email-engine')) {
                        if (params.template.type === 'reminderMandate') {
                            const { data } = await getMandateTemplate({
                                contact: {
                                    id: params.linkedid,
                                    type: params.type,
                                },
                            });
                            if (data) {
                                params.template.subject = data.subject;
                                params.template.content = data.content;
                                if (data.attachments && data.attachments.length) {
                                    params.template.attachments = data.attachments;
                                }
                            }
                        } else {
                            const { data } = await getSystemEmailTemplate(params.template.type, {
                                contact: params.template.contact,
                                related: params.template.related,
                            });
                            if (data) {
                                params.template.subject = data.subject;
                                params.template.content = data.content;
                                if (data.attachments && data.attachments.length) {
                                    params.template.attachments = data.attachments;
                                }
                            }
                        }
                    } else {
                        const template = params.template.type;
                        params.template = template;
                        delete params.linkedid;
                        delete params.type;
                    }
                }

                if (Feature.isEnabled('email-engine')) {
                    let docFile = {};
                    if (this.automaticallyAttachDocument && this.docFile) {
                        docFile = this.docFile.data;
                        if (docFile.related.length === 0) {
                            const relatedType = this.linkedtype ?? this.doctype;
                            const relatedId = this.linkedid ?? this.docid;
                            if (
                                ['invoice', 'estimate'].includes(relatedType) &&
                                isNaN(relatedId) === false
                            ) {
                                docFile.related = [
                                    {
                                        type: relatedType,
                                        id: parseInt(relatedId),
                                    },
                                ];
                            }
                        }
                    }

                    EventBus.emit('emailPanel:new', {
                        params: [
                            this.linkedtype ?? this.doctype,
                            this.linkedid?.toString() ?? this.docid.toString(),
                            params,
                            prefill,
                            email,
                            this.signature,
                            this.doclabel ?? '',
                            docFile,
                        ],
                    });
                } else {
                    EmailAdapter.openSendTab(this.linkedtype, this.linkedid, params);
                }
            } else {
                this.$router.push({
                    name: 'onboarding.email',
                });
            }
        },
    },
};
